import Client from "./client";

export const getSettings = async () => {
  const response = await Client.Admin.get("/admin/settings");
  return response.data;
};

export const getSetting = async (key) => {
  const response = await Client.Admin.get(`/admin/settings?key=${key}`);
  return response.data;
};

export const updateSetting = async (key, value) => {
  const response = await Client.Admin.put(`/admin/settings/${key}`, { value });
  return response.data;
};

export const sendTestEmail = async () => {
  const response = await Client.Admin.post("/admin/settings/test-email");
  return response.data;
};

